'use strict';
// 21.2.5.3 get RegExp.prototype.flags
var anObject = require('./_an-object');
module.exports = function(){
  var that   = anObject(this)
    , result = '';
  if(that.global)     result += 'g';
  if(that.ignoreCase) result += 'i';
  if(that.multiline)  result += 'm';
  if(that.unicode)    result += 'u';
  if(that.sticky)     result += 'y';
  return result;
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_flags.js
// module id = ./node_modules/core-js/modules/_flags.js
// module chunks = 2